import type { CEventsCalendarTranslations } from "./pl";

export const de: CEventsCalendarTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyList: "Keine Veranstaltungen zum Anzeigen.",
  emptyFiltered: "Keine Veranstaltungen für den gewählten Zeitraum.",
  readMore: "Ansehen ->",
  backToList: "<- Zurück zur Liste",
  filtersLegend: "Veranstaltungsdatum wählen",
  allYears: "Jahr",
  allMonths: "Monat",
  resetFilter: "Filter zurücksetzen",
  gallery: "Galerie",
  monthName: (m) => {
    const months = [
      "Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember",
    ];
    return months[m - 1] ?? String(m);
  },
  /** `formatDate("2026-05-13")` -> "13. Mai 2026". */
  formatDate: (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const months = [
      "Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember",
    ];
    const month = parseInt(m[2], 10) - 1;
    if (month < 0 || month > 11) return iso;
    return `${parseInt(m[3], 10)}. ${months[month]} ${m[1]}`;
  },
};
